(function () {
  'use strict';

  var searchWrapper;
  var searchOpener;

  function setKeyboardNavigationMode(enabled) {
    document.documentElement.classList.toggle('a11y-keyboard-navigation', enabled);
  }

  function isSearchOpen() {
    return searchWrapper && searchWrapper.classList.contains('in');
  }

  function getSearchControls() {
    if (!searchWrapper) return [];

    return Array.prototype.filter.call(
      searchWrapper.querySelectorAll('input, button, a[href], [tabindex]:not([tabindex="-1"])'),
      function (element) {
        return !element.disabled && element.offsetParent !== null;
      }
    );
  }

  function focusSearchInput() {
    var searchInput = searchWrapper && searchWrapper.querySelector('.search-input');
    if (!searchInput) return;

    window.requestAnimationFrame(function () {
      searchInput.focus();
    });
  }

  function handleSearchKeydown(event) {
    if (!isSearchOpen()) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      var closeButton = searchWrapper.querySelector('.btn-close');
      if (closeButton) closeButton.click();
      return;
    }

    if (event.key !== 'Tab') return;

    var controls = getSearchControls();
    if (!controls.length) return;

    // Rapid Search is injected elsewhere in the document and may intercept
    // the browser's default Tab movement. Move focus ourselves so it cannot
    // scroll or reposition the results panel.
    event.preventDefault();
    var currentIndex = controls.indexOf(document.activeElement);
    var nextIndex;

    if (currentIndex === -1) {
      nextIndex = event.shiftKey ? controls.length - 1 : 0;
    } else if (event.shiftKey) {
      nextIndex = (currentIndex - 1 + controls.length) % controls.length;
    } else {
      nextIndex = (currentIndex + 1) % controls.length;
    }

    controls[nextIndex].focus();
  }

  function handleSearchShown() {
    document.documentElement.classList.add('search-overlay-open');
    focusSearchInput();
  }

  function handleSearchHidden() {
    document.documentElement.classList.remove('search-overlay-open');
    if (searchOpener && document.documentElement.contains(searchOpener)) {
      searchOpener.focus();
    }
    searchOpener = null;
  }

  function initializeSearchAccessibility() {
    searchWrapper = document.getElementById('searchWrapper');

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') setKeyboardNavigationMode(true);
      if (searchWrapper) handleSearchKeydown(event);
    }, true);

    document.addEventListener('pointerdown', function () {
      setKeyboardNavigationMode(false);
    }, true);

    if (!searchWrapper) return;

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[aria-controls="searchWrapper"]');
      if (opener && !opener.classList.contains('btn-close')) searchOpener = opener;
    });

    if (window.jQuery) {
      window.jQuery(searchWrapper)
        .on('shown.bs.collapse', handleSearchShown)
        .on('hidden.bs.collapse', handleSearchHidden);
    }

    // Bootstrap's event fires after its transition. This fallback also covers
    // environments where collapse is provided without the namespaced events.
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[aria-controls="searchWrapper"]')) return;
      window.setTimeout(function () {
        if (isSearchOpen()) handleSearchShown();
        else handleSearchHidden();
      }, 400);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSearchAccessibility);
  } else {
    initializeSearchAccessibility();
  }
})();
